export const CELL_WIDTH = 24;
export const CELL_HEIGHT = 24;
export const HEADER_DAY_HEIGHT = 36;
export const LEFT_COLUMN = 175;
export const CELL_SPACING = 1;
export const CUSTOM_PADDING = 2.5;

export const HOLIDAY_GREEN = '#43a047';
export const MILITARY_REHEARSAL_BROWN = '#a06a34';
export const SICK_LEAVE_RED = '#d70000';
export const MATERNITY_LEAVE_BLUE = '#07a2c5';
export const STUDY_LEAVE_YELLOW = '#ffd200';
export const WEEKEND_GRAY = '#BEBEBE';
export const DAY_GRAY = '#E8E8E8';
export const CUSTOM_HOLIDAY_PURPLE = '#800075';
export const PUBLIC_HOLIDAY = '#196400';
export const OTHER = '#1457cb';
